import Cart from './Cart'
import ccCartNew from './CartNew'
export let CartNew = ccCartNew
export default  Cart



// WEBPACK FOOTER //
// ./components/pages/order/Cart/index.js